import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { fetchTeamSprintsInRange } from '../services/fetchTeamSprintsInRange';
import { Sprint } from '../types';

export function useGetSprints(
  teamId: string | null,
  startDate: string,
  endDate: string,
): UseQueryResult<Sprint[], Error> {
  return useQuery<Sprint[], Error>({
    queryKey: ['sprints', teamId, startDate, endDate],
    queryFn: () => fetchTeamSprintsInRange(teamId, startDate, endDate),
    enabled: !!teamId && !!startDate && !!endDate,
  });
}
